import { webStorage } from "@/lib/web-storage"

const STORAGE_KEY = "mindtrip.pending_ios_flight_handoff"

export function recordPendingIosFlightHandoff(destination: string): void {
  webStorage.setItem(STORAGE_KEY, destination, { type: "session" })
}

export function consumePendingIosFlightHandoff(destination: string): boolean {
  const storedDestination = webStorage.getItem(STORAGE_KEY, { type: "session" })
  webStorage.removeItem(STORAGE_KEY, { type: "session" })
  return storedDestination === destination
}

export function clearPendingIosFlightHandoff(): void {
  webStorage.removeItem(STORAGE_KEY, { type: "session" })
}
